'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}let

ClassExtensions=function(){
function ClassExtensions(instance){_classCallCheck(this,ClassExtensions);
this._instance=instance;
}ClassExtensions.prototype.

defineLazyGetter=function defineLazyGetter(getterKey,fn){
let computed=!1;
let result;
Object.defineProperty(this._instance,getterKey,{
get:function(){
if(computed){
return result;
}

result=fn();
computed=!0;
return result;
}});

};ClassExtensions.prototype.

defineLazyGetters=function defineLazyGetters(keyFnMap){
for(const key in keyFnMap){
this.defineLazyGetter(key,keyFnMap[key]);
}
};ClassExtensions.

extend=function extend(instance){
return new ClassExtensions(instance);
};return ClassExtensions}();


module.exports=ClassExtensions.extend;
//# sourceMappingURL=classExtensions.js.map
